import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { fetchDocument, fetchDocuments } from '../../common/redux/collectionActions'
import { _unallocateDoor } from './actions'
import "../Cluster/cluster.css"
import { unallocateDoor } from './actions'
import { swalWarning } from "../../common/components/Swaler"

import DeliveryBox from './DeliveryBox'
import EasyAccessBox from './EasyAccessBox'


class AllocatedDoor extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    // alloc_component(door, i) {
    //     const alloc_type = Object.keys(door.allocation).find(alloc => {
    //         return !!door.allocation[alloc]
    //     })

    //     const allocId = door.allocation[alloc_type]

    //     switch (alloc_type) {
    //         case "easy_access":

    //             const easy_access = this.props.easy_accesses.find(ea => ea._id === door.allocation[alloc_type])
    //             const customer = this.props.customers.find(c => c.phone === easy_access.target)

    //             let easyAccessDisplayName
    //             if (customer) {
    //                 easyAccessDisplayName = `${customer.name} ${customer.surname}`
    //             } else {
    //                 easyAccessDisplayName = `${easy_access.target}`
    //             }

    //             return (
    //                 <span>
    //                     <div>Bokad till: <span key={i} className="cluster-box-status" style={{ color: "#53585f", fontWeight: "bold" }}>{easyAccessDisplayName}</span></div>
    //                     <br />
    //                 </span>
    //             )
    //         case "delivery":
    //             let deliveryDisplayName = ""

    //             const { deliveries, keyedCustomers } = this.props
    //             const thisDelivery = deliveries.find(d => d._id === allocId)

    //             if (thisDelivery) {
    //                 const thisCustomer = keyedCustomers[thisDelivery.to_customer]
    //                 if (thisCustomer) {
    //                     if (thisCustomer.name) {
    //                         deliveryDisplayName = `${thisCustomer.name} (${thisCustomer.phone})`
    //                     } else {
    //                         deliveryDisplayName = thisCustomer.phone
    //                     }
    //                 }
    //             }

    //             return (
    //                 <div>
    //                     <div><span key={i} className="cluster-box-status" style={{ color: "#53585f", fontWeight: "bold" }}>{deliveryDisplayName}</span></div>
    //                 </div>
    //             )
    //         case "retur":
    //             return (<b>retur</b>)

    //         default: return null
    //     }
    // }

    // unallocate(door) {

    //     var ea_phone = this.props.easy_accesses.map(ea => {
    //         if (door.allocation.easy_access == ea._id) return ea.target
    //     }).filter(e => e != undefined).toString()

    //     var occupant = this.props.customers.map(cust => {
    //         if (!!cust.phone && cust.phone != undefined) {

    //             if (ea_phone == cust.phone.toString()) {
    //                 return cust.name ? cust.name + " " + cust.surname : ea_phone
    //             }
    //         }
    //     }).filter(e => e != undefined).toString()

    //     var lock_id = this.props.lock._id
    //     var allocation_id
    //     if (!!door.allocation.easy_access) {
    //         allocation_id = door.allocation.easy_access
    //     }
    //     if (!!door.allocation.delivery) {
    //         allocation_id = door.allocation.delivery._id || door.allocation.delivery
    //     }
    //     if (!!door.allocation.retur) {
    //         allocation_id = door.allocation.retur
    //     }

    //     let title = `<p>Avbokar ${door.display_name}</p>`
    //     let html = `<p>Vill du ta bort bokningen för ${occupant ? occupant : ea_phone}?</p>`
    //     let showCancelButton = true
    //     let cancelButtonText = "Avbryt"
    //     let confirmButtonText = "Ja"
    //     swalWarning(title, confirmButtonText, cancelButtonText, showCancelButton, html)
    //         .then(({ value }) => {
    //             this.props.closeModal()
    //             if (!value) return
    //             if (door.allocation.delivery) { //tills att vi fixat samma route för easyaccess
    //                 this.props._unallocateDoor(door._id)
    //             } else {
    //                 this.props.unallocateDoor(door._id, allocation_id)
    //             }
    //         }).catch(err => { })
    // }

    getAllocation = (door) => {
        const [type, id] = Object.entries(door.allocation).find((pair) => {
            return !!pair[1]
        })

        return { type, id }
    }

    render() {
        const { door } = this.props

        const allocation = this.getAllocation(door)

        switch (allocation.type) {
            case "delivery": return <DeliveryBox key={allocation.id} allocation={allocation} door={door} />
            case "easy_access": return <EasyAccessBox key={allocation.id} allocation={allocation} door={door} />
            default: return <p>Saknar komponent</p>
        }

        // return (
        //     <Col key={door.id} style={{ marginBottom: "50px" }} xs={12} md={3}>
        //         <div className="cluster-box-allocated">
        //             <div className="cluster-box-title">
        //                 <b>{door.display_name ? door.display_name : "Paketbox " + (key + 1)}</b>
        //             </div>
        //             <hr style={{ width: "95%" }} />
        //             <div className="cluster-box-status">
        //                 Status:
        //                 <span>
        //                     <span style={{ fontWeight: "bold", color: "rgb(187, 16, 16)" }}> Bokad {this.allocationType(door.allocation)}</span>
        //                     {this.alloc_component(door, key)}
        //                 </span>
        //             </div>
        //             <div className="cluster-box-button" onClick={() => this.props.openModal(door.id)}>
        //                 Visa mer
        //             </div>
        //         </div>
        //         <div>
        //             <Modal
        //                 isOpen={this.props.isOpen}
        //                 onRequestClose={this.props.closeModal}
        //                 style={customStyles}>

        //                 <div style={{ padding: "20px" }}>
        //                     <div className="cluster-box-modal-close" onClick={this.props.closeModal}>X</div>
        //                     <h2 style={{ marginTop: "-0px", textAlign: "center" }}>{door.display_name}</h2>
        //                     <hr />
        //                     <Row style={{ marginBottom: "20px" }}>
        //                         <Col md={12}>
        //                             <div style={{ fontSize: "20px" }} >{this.alloc_component(door, key)}</div>
        //                         </Col>
        //                     </Row>
        //                     <Row style={{ marginBottom: "20px" }}>
        //                         <Col md={12}>
        //                             <span style={{ marginBottom: "10px", fontSize: "18px" }}>{easy_access ? "Giltighetstid:" : ""}</span>
        //                             {easy_access && easy_access.unlimited_uses == true ?
        //                                 <Row style={{ marginBottom: "10px" }}>
        //                                     <span style={{ fontWeight: "bold", fontSize: "20px" }}>{moment(easy_access.timeframe.start).format("DD/MM [kl]HH:mm")}</span>
        //                                     <span style={{ fontWeight: "bold", marginRight: "10px", marginLeft: "10px", fontSize: "20px" }}> - </span>
        //                                     <span style={{ clear: "both", fontWeight: "bold", fontSize: "20px" }}>{moment(easy_access.timeframe.end).format("DD/MM [kl]HH:mm")}</span>
        //                                 </Row>
        //                                 :
        //                                 <span style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px" }}>{!delivery ? "Engångsnyckel" : ""}</span>
        //                             }


        //                             {/* {delivery ? <DeliveryBox delivery={delivery} /> : null} */}
        //                         </Col>
        //                     </Row>
        //                     <Button className="cluster-box-unallocate" onClick={() => this.unallocate(door, i)}>Avboka paketlåda</Button>
        //                 </div>
        //             </Modal>
        //         </div>
        //     </Col>
        // )
    }
}

const mapStateToProps = (state) => {
    return {
        easy_accesses: state.collectionData.easy_accesses,
        deliveries: state.collectionData.deliveries
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchDocument: (_delivery, collection_type, lock_id) => dispatch(fetchDocument(_delivery, collection_type, lock_id)),
        unallocateDoor: (door_id, allocation_id) => dispatch(unallocateDoor(door_id, allocation_id)),
        fetchDocuments: (...args) => dispatch(fetchDocuments(...args)),
        _unallocateDoor: (...args) => dispatch(_unallocateDoor(...args))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllocatedDoor)